export const WARNING_SESSION_COUNT = 3 // Number of sessions left before displaying a warning
